/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { I18nMessage } from "@i18n/next";
import type { ThemeType } from "@packages/ui";
import { Text } from "@packages/ui";
import {
  differenceInDays,
  formatDate,
  isBefore,
  parseISO,
  startOfDay,
} from "date-fns";

const cssText: Interpolation<ThemeType> = (theme) => ({
  borderRadius: 4,
  paddingBottom: theme.spacing.xxs,
  paddingLeft: theme.spacing.xs,
  paddingRight: theme.spacing.xs,
  paddingTop: theme.spacing.xxs,
  width: "fit-content",
});
const cssTagExpired: Interpolation = {
  backgroundColor: "rgba(220,55,45,0.1)",
  color: "rgba(220,55,45,1)",
};
const cssTagExpiringSoon: Interpolation = {
  backgroundColor: "rgba(199,112,25,0.1)",
  color: "rgba(199,112,25,1)",
};
const cssTagActive: Interpolation = {
  backgroundColor: "rgba(9,137,60,0.1)",
  color: "rgba(9,137,60,1)",
};

export const SubscriptionText = ({
  isShowDate,
  subscription_end_date,
}: {
  isShowDate?: boolean;
  subscription_end_date: string;
}) => {
  if (!subscription_end_date) return null;

  if (
    isBefore(
      startOfDay(parseISO(subscription_end_date as string)),
      startOfDay(new Date()),
    )
  )
    return (
      <Text css={[cssText, cssTagExpired]} size="s" type="body">
        <I18nMessage message="user_sub_status_expired" />{" "}
        {isShowDate && (
          <span>{formatDate(subscription_end_date, "MM/dd/yyyy")}</span>
        )}
      </Text>
    );

  if (
    differenceInDays(
      startOfDay(parseISO(subscription_end_date as string)),
      startOfDay(new Date()),
    ) <= 60
  )
    return (
      <Text css={[cssText, cssTagExpiringSoon]} size="s" type="body">
        <I18nMessage message="general_words_expiring_soon" />
        {isShowDate && (
          <span>&nbsp;{formatDate(subscription_end_date, "MM/dd/yyyy")}</span>
        )}
      </Text>
    );

  return (
    <Text css={[cssText, cssTagActive]} size="s" type="body">
      <I18nMessage message="user_sub_status_active" />
    </Text>
  );
};
